var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistorial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.71436C17.6806 1.71436 22.2857 6.31943 22.2857 12.0001C22.2857 17.6807 17.6806 22.2858 12 22.2858C9.23509 22.2858 6.64175 21.1886 4.72571 19.272C4.39103 18.9372 4.39112 18.3945 4.72591 18.0598C5.0607 17.7251 5.60341 17.7252 5.93809 18.06C7.53581 19.6582 9.69451 20.5715 12 20.5715C16.7339 20.5715 20.5714 16.7339 20.5714 12.0001C20.5714 7.2662 16.7339 3.42864 12 3.42864C9.65265 3.42864 7.46594 4.37838 5.87767 6.00039L7.28571 6.00007C7.7591 6.00007 8.14286 6.38383 8.14286 6.85721C8.14286 7.29679 7.81197 7.65907 7.38567 7.70859L7.28571 7.71435H3.85714C3.41757 7.71435 3.05528 7.38346 3.00577 6.95717L3 6.85721V3.42864C3 2.95525 3.38376 2.5715 3.85714 2.5715C4.29672 2.5715 4.65901 2.90239 4.70852 3.32868L4.71429 3.42864L4.71406 4.739C6.61436 2.83084 9.21384 1.71436 12 1.71436ZM12 6.85721C12.4396 6.85721 12.8019 7.1881 12.8514 7.61439L12.8571 7.71435V11.645L15.1775 13.9654C15.5123 14.3001 15.5123 14.8429 15.1775 15.1776C14.8685 15.4866 14.3823 15.5103 14.0461 15.2489L13.9653 15.1776L11.3939 12.6062C11.26 12.4722 11.1749 12.2985 11.1503 12.1127L11.1429 12.0001V7.71435C11.1429 7.24097 11.5266 6.85721 12 6.85721Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistorial);
export default __webpack_public_path__ + "static/media/historial.fa41096cabaaa8713bce7cadfc3539a1.svg";
export { ForwardRef as ReactComponent };